import { styled } from '@mui/system';

import { ExtendedToggleButtonGroup } from '.';

export const StyledToggleButtonGroup = styled(ExtendedToggleButtonGroup)(
  ({ theme, numberofbuttons, shouldstayinonerow }) => ({
    width: '100%',
    display: 'grid',
    gap: theme.spacing(2),
    gridTemplateColumns: `repeat(${numberofbuttons}, 1fr)`,
    gridTemplateRows: 'repeat(1, 1fr)',
    overflowX: 'scroll',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    [`${!shouldstayinonerow && theme.breakpoints.up('sm')}`]: {
      gridTemplateColumns: numberofbuttons < 4 ? `repeat(3, auto)` : `repeat(4, minmax(auto, 1fr))`,
      gridTemplateRows: `repeat(${numberofbuttons / 4}, 1fr)`,
    },
  }),
);

export const InfoCardVariantStyledToggleButtonGroup = styled(ExtendedToggleButtonGroup)(
  ({ theme, numberofbuttons, shouldstayinonerow }) => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    gap: theme.spacing(4),
    gridTemplateColumns: `repeat(${numberofbuttons}, 1fr)`,
    gridTemplateRows: 'repeat(1, 1fr)',
    overflowX: 'scroll',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    [`${!shouldstayinonerow && theme.breakpoints.up('sm')}`]: {
      gridTemplateColumns: numberofbuttons < 4 ? `repeat(3, auto)` : `repeat(4, minmax(auto, 1fr))`,
      gridTemplateRows: `repeat(${numberofbuttons / 4}, 1fr)`,
    },
  }),
);
